import { format } from "date-fns";

// Kept separate from exportData.ts so Table.tsx can import it statically —
// exportData.ts pulls in jspdf/xlsx/papaparse and is loaded on demand.
export function getExportFileName(exportFileName) {
  const fn = ({ fileType, all }) => {
    return `${exportFileName} ${format(new Date(), "dd-mm-yyyy")}`;
  };

  return fn;
}
